module.exports = __webpack_public_path__ + "img/cyclogest.2bc3c71f.jpg";